import React from 'react';
import axios from "../../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../../helpers/Utils";
import {Button, CardBody, Input, Row, FormGroup, Label, CustomInput} from "reactstrap";
import {Colxx, Separator} from "../../../../../components/common/CustomBootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
class AddLoadHall extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          
            LoadHallId: null,
            NewLoadHallName: null,
            NewLoadHallTel: null,
            ReservationLimit: 0,
            LimitNewTurn: 0,
            TravelTime: 0,
            LoadHallLat: null,
            LoadHallLong: null,
            IsActive: true,
            TurnExpireHour: 0, 
            DriverCharghe: 0, 
            TransportationCompanyCharghe: 0, 
            NativeTurnExpireHour: 0, 
            ReservationRange: 0, 
            ActiveTurnApp: false,
            IsActiveShowTime: false,
            IsFreeCargo: false,
            CityList: [],
            City: null,
            SaveType: this.props.SaveType,
            LoadHallToEdit: this.props.LoadHallToEdit,
  
        }
    }
   
    loadLoadHallCity = () => {
        this.props.showSpinner();
        axios.get('api/v1/load-hall-cities/cities')
            .then((res) => {
                const cityList = res.data.data;
                this.props.hideSpinner();

                this.setState({ CityList: cityList }, () => {
                    // اگر در حالت ویرایش هستیم، بعد از اینکه CityList تنظیم شد، مقدار City را تنظیم کن
                    if (this.state.SaveType === 'Edit' && this.state.LoadHallToEdit) {
                        const selectedCity = cityList.find(v => v.cityId === this.state.LoadHallToEdit.loadHallCityId);
                        if (selectedCity) {
                            this.setState({ City: selectedCity });
                        }
                    }
                });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    componentDidMount() {
        this.loadLoadHallCity();
        if (this.state.SaveType === 'Edit') {
            this.setState({
                NewLoadHallName: (this.state.LoadHallToEdit.name),
                NewLoadHallTel:  (this.state.LoadHallToEdit.tel),
                ReservationLimit:  (this.state.LoadHallToEdit.reservationLimit),
                ReservationRange:  (this.state.LoadHallToEdit.reservationRange),
                ActiveTurnApp: this.state.LoadHallToEdit.activeTurnApp,
                IsActiveShowTime: this.state.LoadHallToEdit.isActiveShowTime,
                IsFreeCargo: this.state.LoadHallToEdit.isFreeCargo,
                
                IsActive: this.state.LoadHallToEdit.isActive,
                LoadHallLat:  (this.state.LoadHallToEdit.loadHallLat),
                LoadHallLong:  (this.state.LoadHallToEdit.loadHallLong),
                TurnExpireHour: (this.state.LoadHallToEdit.turnExpireHour),
                DriverCharghe: (this.state.LoadHallToEdit.driverCharghe),
                TransportationCompanyCharghe: (this.state.LoadHallToEdit.transportationCompanyCharghe),
                NativeTurnExpireHour: (this.state.LoadHallToEdit.nativeTurnExpireHour),
                LoadHallId: (this.state.LoadHallToEdit.loadHallId),
                LimitNewTurn: (this.state.LoadHallToEdit.limitNewTurn),
                TravelTime: (this.state.LoadHallToEdit.travelTime),

                //NewLoadHallName: toEnglishNumbers(this.state.LoadHallToEdit.name),
                //NewLoadHallTel: toEnglishNumbers(this.state.LoadHallToEdit.tel),
                //ReservationLimit: toEnglishNumbers(this.state.LoadHallToEdit.reservationLimit),
                //ReservationRange: toEnglishNumbers(this.state.LoadHallToEdit.reservationRange),
                //ActiveTurnApp: this.state.LoadHallToEdit.activeTurnApp,
                //IsActive: this.state.LoadHallToEdit.isActive,
                //LoadHallLat: toEnglishNumbers(this.state.LoadHallToEdit.loadHallLat),
                //LoadHallLong: toEnglishNumbers(this.state.LoadHallToEdit.loadHallLong),
                //TurnExpireHour: toEnglishNumbers(this.state.turnExpireHour),


            })
            
        }

        
    }
    addLoadHall = () => {
        if (this.state.NewLoadHallName === null || this.state.NewLoadHallName === '') {
            this.props.showAlert('وارد كردن نام سالن الزامی میباشد', 'error');
            return;
        }

        if (this.state.ReservationLimit !== null || this.state.ReservationLimit !== undefined) {
            if (this.state.ReservationLimit > 25) {
                this.props.showAlert('مدت زمان مجاز برای اولویت ‌بندی نميتواند بزارگتر از 25 باشد', 'error');
                return;
            }

        }
       
        

        let NewLoadHall = {
            Name: toEnglishNumbers(this.state.NewLoadHallName),
            Tel: toEnglishNumbers(this.state.NewLoadHallTel),
            ReservationLimit: toEnglishNumbers(this.state.ReservationLimit),
            ReservationRange: toEnglishNumbers(this.state.ReservationRange),
            ActiveTurnApp: this.state.ActiveTurnApp,
            IsActiveShowTime: this.state.IsActiveShowTime,
            IsFreeCargo: this.state.IsFreeCargo,
            LoadHallCityId: this.state.City !== null ? this.state.City.cityId : null, 
            IsActive:  this.state.IsActive ,
            LoadHallLat: toEnglishNumbers(this.state.LoadHallLat),
            LoadHallLong: toEnglishNumbers(this.state.LoadHallLong),
            DriverCharghe: toEnglishNumbers(this.state.DriverCharghe),
            TransportationCompanyCharghe: toEnglishNumbers(this.state.TransportationCompanyCharghe),
            TurnExpireHour: (this.state.TurnExpireHour === null || this.state.TurnExpireHour === undefined) ? 0 : toEnglishNumbers(this.state.TurnExpireHour),
            NativeTurnExpireHour: (this.state.NativeTurnExpireHour === null || this.state.NativeTurnExpireHour === undefined) ? 0 : toEnglishNumbers(this.state.NativeTurnExpireHour),
            LimitNewTurn: (this.state.LimitNewTurn === null || this.state.LimitNewTurn === undefined) ? 0 : toEnglishNumbers(this.state.LimitNewTurn),
            TravelTime: (this.state.TravelTime === null || this.state.TravelTime === undefined) ? 0 : toEnglishNumbers(this.state.TravelTime),
            Id:null
        }
        let metode = 'AddLoadHall';
        if (this.state.SaveType === 'Edit') {
            metode = 'UpdateLoadHall';
            NewLoadHall.Id = this.state.LoadHallId
        }

        this.props.showSpinner(); 
        axios.post('/api/v1/load-halls/' + metode, NewLoadHall)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.props.closeModal("AddModal");
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    selectHandleChange = (event, value, name) => {
         

        this.setState({ [name]: value });
    };
    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>*نام</Label>
                                <Input value={this.state.NewLoadHallName} placeholder="نام کامل سالن"
                                       onChange={(e) => this.setState({NewLoadHallName: e.target.value})}/>
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>تلفن</Label>
                                <Input value={this.state.NewLoadHallTel} maxLength={11}
                                       onChange={(e) => this.setState({NewLoadHallTel: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>
                          
                        </div>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>محدوده رزرو</Label>
                                <Input value={this.state.ReservationRange} maxLength={15}
                                       onChange={(e) => this.setState({ReservationRange: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>
 

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مبدا</Label>
                                <Input value={this.state.LoadHallLat} maxLength={300}
                                    onChange={(e) => this.setState({ LoadHallLat: e.target.value.replace(/[^.0-9۰-۹]/g, "") })} />
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مقصد</Label>
                                <Input value={this.state.LoadHallLong} maxLength={300}
                                    onChange={(e) => this.setState({ LoadHallLong: e.target.value.replace(/[^.0-9۰-۹]/g, "") })} />
                            </FormGroup>

                            
                        </div>

                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            

                           

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مدت زمان مجاز برای اولویت‌بندی</Label>
                                <Input value={this.state.ReservationLimit} maxLength={15}
                                       onChange={(e) => this.setState({ReservationLimit: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>

                              <FormGroup className="w-md-25 w-100 px-1">
                                <Label>محدوديت دريافت نوبت جديد</Label>
                                <Input value={this.state.LimitNewTurn} maxLength={15}
                                    onChange={(e) => this.setState({ LimitNewTurn: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مدت زمان سفر</Label>
                                <Input value={this.state.TravelTime} maxLength={15}
                                    onChange={(e) => this.setState({ TravelTime: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>
                        </div>
                            <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>شهر</Label>
                                <Autocomplete
                                    clearText={"حذف"}
                                    closeText={"بستن"}
                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                    openText={"باز کردن"}
                                    className="react-select__control"
                                    id="City"
                                    options={this.state.CityList}
                                    getOptionLabel={(option) => option.cityName}
                                    value={this.state.City}
                                    onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                />
                            </FormGroup>
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مدت اعتبار نوبت  (ساعت)</Label>
                                <Input value={this.state.TurnExpireHour} maxLength={11}
                                    onChange={(e) => this.setState({ TurnExpireHour: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                            </FormGroup>
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مدت اعتبار نوبت ویژه ها  (ساعت)</Label>
                                <Input value={this.state.NativeTurnExpireHour} maxLength={11}
                                    onChange={(e) => this.setState({ NativeTurnExpireHour: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                            </FormGroup>
                           
                        </div>

                        <Separator className="my-5" />

                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3 salon-checkboxes">
                             

                            <FormGroup className="w-md-20 w-100 px-1">
                                <CustomInput
                                    type="checkbox"
                                    id="IsActive"
                                    name="IsActive"
                                    label="فعال"
                                    checked={this.state.IsActive}
                                    onChange={() => this.setState({IsActive: !this.state.IsActive})}
                                />
                            </FormGroup> 
                            <FormGroup className="w-md-20 w-100 px-1">
                                <CustomInput
                                    type="checkbox"
                                    id="ActiveTurnApp"
                                    name="ActiveTurnApp"
                                    label="فعال بودن نوبت‌دهی اپ"
                                    checked={this.state.ActiveTurnApp}
                                    onChange={() => this.setState({ ActiveTurnApp: !this.state.ActiveTurnApp })}
                                />
                            </FormGroup>
                            <FormGroup className="w-md-20 w-100 px-1">
                                <CustomInput
                                    type="checkbox"
                                    id="IsActiveShowTime"
                                    name="IsActiveShowTime"
                                    label="فعال بودن ساعت های اعلام بار"
                                    checked={this.state.IsActiveShowTime}
                                    onChange={() => this.setState({ IsActiveShowTime: !this.state.IsActiveShowTime })}
                                />
                            </FormGroup>     <FormGroup className="w-md-20 w-100 px-1">
                                <CustomInput
                                    type="checkbox"
                                    id="IsFreeCargo"
                                    name="IsFreeCargo"
                                    label="آیا بار آزاد شود؟"
                                    checked={this.state.IsFreeCargo}
                                    onChange={() => this.setState({ IsFreeCargo: !this.state.IsFreeCargo })}
                                />
                            </FormGroup>    
                        </div>

                        <Separator className="my-5" /> 
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مبلغ رزرو راننده</Label>
                                <Input
                                    value={this.state.DriverCharghe}
                                    maxLength={300}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9۰-۹]/g, ""); // فقط اعداد
                                         

                                        // حذف صفرهای اضافه اول عدد (مگر اینکه فقط 0 باشه)
                                        if (value.length > 1) {
                                            value = value.replace(/^0+/, "");
                                        }

                                        // اگر خالی شد → بذار 0
                                        if (value === "") value = "0";

                                        this.setState({ DriverCharghe: value });
                                    }}
                                />
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>مبلغ رزرو شرکت</Label>
                                <Input
                                    value={this.state.TransportationCompanyCharghe}
                                    maxLength={300}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9۰-۹]/g, ""); // فقط عدد انگلیسی و فارسی 

                                        // حذف صفرهای اضافی اول عدد
                                        if (value.length > 1) {
                                            value = value.replace(/^0+/, "");
                                        }

                                        // اگر کاربر همه چیز رو پاک کرد، مقدار رو صفر بذار
                                        if (value === "") value = "0";

                                        this.setState({ TransportationCompanyCharghe: value });
                                    }}
                                />
                            </FormGroup>

                        </div>
                        <Separator className="my-5" /> 

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2"
                                    onClick={() => this.addLoadHall()}>
                                    افزودن
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default AddLoadHall;